import React, { useState, useEffect } from "react";
import UserCard from "../users/UserCard";
import Col from "react-bootstrap/Col";
import Row from 'react-bootstrap/Row';
import Dropdown from "react-bootstrap/Dropdown";
import Collapse from "react-bootstrap/Collapse";
import {createElementFromHTML, formatDate} from "../../utils/utilsHelpers";
import {sanitizeRedactorContent} from "../../utils/postingHelpers";
// import CommentActions from "./CommentActions";
import { JSON_HEADERS, COMPANY_NAME } from "../../constants/constants";
import ReportContent from "../actions/ReportContent";
import ConfirmModal from "../modals/ConfirmModal";
import ResponseModal from "../modals/ResponseModal";
import ReplyUpdate from "./ReplyUpdate";

export default function ReplyCard(props) {
    let {
        reply,
        commentId,
        commentAuthor,
        readOnly=false,
        currentUser={},
        showDate,
        token,
        lastItem=false,
        toggleRegistration=()=>{},
        leadData={}
    } = props;

    // Also in props: onDeleteReply
    const [thisReply, setThisReply] = useState(reply);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDeleteResponseModal, setShowDeleteResponseModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const userSignedIn = !!currentUser;
    const viewingSelf = userSignedIn && currentUser.id == thisReply.author.id;
    const adminUser = userSignedIn && currentUser.admin;

    // event handlers

    const onDeleteHandler = async() => {
        await fetch(thisReply.actions.delete, {
            method: 'DELETE',
            headers: JSON_HEADERS,
            body: JSON.stringify({ authenticity_token: token })
        });

        setShowDeleteModal(false);
        setShowDeleteResponseModal(true);
        props.onDeleteReply(thisReply.id);
    }

    const onReplyUpdate = (uReply) => {
        setThisReply({ ...thisReply, body: uReply.body})
        setIsEditing(false);
    }

    const onReplyUpdateCancel = () => {
        setIsEditing(false);
    }

    const onCancelConfirm = () => setShowDeleteModal(false);
    const onHandleDeleteResponse = () => setShowDeleteResponseModal(false);

    // render methods

    const renderDeleteConfirm = () => {
        if(showDeleteModal) {
            return (
                <ConfirmModal
                    id={thisReply.id}
                    onConfirm={onDeleteHandler}
                    onCancelConfirm={onCancelConfirm}
                    header={'Are you sure?'}
                    body={`This change will completely remove this reply from ${COMPANY_NAME}.`}
                    confirmTxt={'Confirm delete'}
                    show={showDeleteModal} />
            )
        }
    }

    const renderDeleteResponseModal = () => {
        if(showDeleteResponseModal) {
            return (
                <ResponseModal
                    modalSize={'md'}
                    bgColor={'white'}
                    textColor={'secondary'}
                    btnColor={'primary'}
                    icon={'check-circle'}
                    header={'Confirmed'}
                    message={'Your reply has been removed.'}
                    show={showDeleteResponseModal}
                    handleShow={onHandleDeleteResponse} />
            )
        }
    }


    const renderAdminMenu = () => {
        return (
            <Col xs={1} className={'text-center d-none d-md-block ms-auto'}>
                <Dropdown>
                    <Dropdown.Toggle className={'link-medium px-2'} as={'div'}>
                        <i className={'fas fa-ellipsis-v'}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align={'end'} className={'rounded font-13 py-1 mt-1'}>
                        <Dropdown.Item
                            href={thisReply.author.url}
                            className={'border-bottom'}
                        >
                            <i className={'fal fa-user me-2'}></i>
                            Author profile
                        </Dropdown.Item>

                        {(viewingSelf || adminUser) && <Dropdown.Item
                            // href={thisReply.actions.edit}
                            onClick={() => setIsEditing(true) }
                            className={'border-bottom'}
                        >
                            <i className={'fal fa-pencil me-2'}></i>
                            Edit
                        </Dropdown.Item>}

                        {(adminUser || viewingSelf) && <Dropdown.Item
                            onClick={() => setShowDeleteModal(true)}
                            className={'border-bottom'}
                        >
                            <i className={'fal fa-trash-alt me-2'}></i>
                            Delete
                        </Dropdown.Item>}

                        <Dropdown.Item className={'border-bottom'} as={'div'}>
                            <ReportContent
                                item={reply}
                                itemType={'reply'}
                                itemUrl={thisReply.actions.posting_url}
                                linkClasses={'ms-0 text-gray-dark'}
                                userSignedIn={userSignedIn}
                                token={token}
                                toggleRegistration={toggleRegistration}
                                leadData={leadData}/>
                        </Dropdown.Item>

                    </Dropdown.Menu>
                </Dropdown>
            </Col>

        )
    }

    const renderDate = () => {
        if(showDate)
            return (
                <Row>
                    <Col xs={12} className={'mt-2 gray-600 font-14'}>
                        {formatDate(thisReply.published_date)}
                    </Col>
                </Row>
            )
    }

    const renderCommentBody = () => {
        if(!isEditing) {
            let collapsibleVars = {
                '--collapsible-more': "'Read full reply'",
                '--collapsible-less': "'Close reply'",
                '--collapsible-show-lines': 4
            }
            return (
                <Row className={`mx-0 px-0 py-3 ${!lastItem && 'border-bottom'}`}>
                    <Col xs={12} className={'px-0 comment-body collapsible secondary-links content-cleanup'} style={collapsibleVars}>
                        {createElementFromHTML(sanitizeRedactorContent(thisReply.body))}
                    </Col>
                </Row>
            )
        }
    }

    const renderEditForm = () => {
        if(isEditing) {
            return (
                <div className={'mt-3'}>
                    <ReplyUpdate
                        reply={reply}
                        currentUser={currentUser}
                        token={token}
                        onReplyUpdate={onReplyUpdate}
                        onReplyUpdateCancel={onReplyUpdateCancel}
                    />
                </div>
            )
        }
    }

    return (
        <div className={`comment-card reply published-${!!thisReply.published_date}`}>
            <a className={'position-relative after-topbar'} name={`reply-${thisReply.id}`} id={`reply-${thisReply.id}`} />
            <Row className={'align-items-center'}>
                <div className={`${userSignedIn ? 'col-10' : 'col-12'} px-0`}>
                    <UserCard user={thisReply.author} avatarSize={30} nameFs={15} />
                </div>
                {userSignedIn && !readOnly && renderAdminMenu()}
            </Row>
            {renderDate()}
            {renderCommentBody()}
            {renderEditForm()}
            {renderDeleteConfirm()}
            {renderDeleteResponseModal()}
        </div>
    )
}